export class ControlUtils {

    static buildDropDownOptions(data: any) {

    var options:string[] = [];
    options.push('');        
    options = options.concat(data);  

    return options;
  }
}
